{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "ID",
      "folder": "Crown Land Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "open_rights": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Zone Description",
      "folder": "Crown Land Header",
      "width": 750,
      "isShownByDefault": true,
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
